// Author Lin
// Date 2021-10-11 13:48:09

class MintalMesPrdPelletizingCeramicFilterParameter {
constructor({
        id = null,
        locationId = '',
        recordTime = '',
        current = '',
        grindingQuantity = '',
        waterSupply = '',
        concentration = '',
        granularity = '',
        steelBall = '',
        filterCakeWater1 = '',
        filterCakeWater2 = '',
        filterCakeWater3 = '',
        filterCakeWater4 = '',
        filterCakeWater301 = '',
        slurryFixedCarbon = '',
        pulpCaContent = '',
        stronglyMixedWater = '',
        rawBallCarbon = '',
        rawBallDropStrength = '',
        ripeBallStrength = '',
        conversionIndex = '',
        abrasionIndex = '',
        so2 = '',
        nox = '',
        pm = '',
        recorderId = '',
        reviewerId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.locationId = locationId;
    this.recordTime = recordTime;
    this.current = current;
    this.grindingQuantity = grindingQuantity;
    this.waterSupply = waterSupply;
    this.concentration = concentration;
    this.granularity = granularity;
    this.steelBall = steelBall;
    this.filterCakeWater1 = filterCakeWater1;
    this.filterCakeWater2 = filterCakeWater2;
    this.filterCakeWater3 = filterCakeWater3;
    this.filterCakeWater4 = filterCakeWater4;
    this.filterCakeWater301 = filterCakeWater301;
    this.slurryFixedCarbon = slurryFixedCarbon;
    this.pulpCaContent = pulpCaContent;
    this.stronglyMixedWater = stronglyMixedWater;
    this.rawBallCarbon = rawBallCarbon;
    this.rawBallDropStrength = rawBallDropStrength;
    this.ripeBallStrength = ripeBallStrength;
    this.conversionIndex = conversionIndex;
    this.abrasionIndex = abrasionIndex;
    this.so2 = so2;
    this.nox = nox;
    this.pm = pm;
    this.recorderId = recorderId;
    this.reviewerId = reviewerId;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdPelletizingCeramicFilterParameter();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationId',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.locationId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'recordTime',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.recordTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'current',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.current',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'grindingQuantity',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.grindingQuantity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'waterSupply',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.waterSupply',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'concentration',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.concentration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'granularity',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.granularity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'steelBall',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.steelBall',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'filterCakeWater1',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.filterCakeWater1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'filterCakeWater2',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.filterCakeWater2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'filterCakeWater3',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.filterCakeWater3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'filterCakeWater4',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.filterCakeWater4',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'filterCakeWater301',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.filterCakeWater301',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slurryFixedCarbon',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.slurryFixedCarbon',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pulpCaContent',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.pulpCaContent',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'stronglyMixedWater',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.stronglyMixedWater',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rawBallCarbon',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.rawBallCarbon',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rawBallDropStrength',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.rawBallDropStrength',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ripeBallStrength',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.ripeBallStrength',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'conversionIndex',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.conversionIndex',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'abrasionIndex',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.abrasionIndex',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'so2',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.so2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nox',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.nox',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pm',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.pm',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'recorderId',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.recorderId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'recorder',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.recorder',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reviewerId',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.reviewerId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reviewer',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.reviewer',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    locationIdFilter : "",
    recordTimeRteFilter : "",
    recordTimeLteFilter : "",
    currentFilter : "",
    grindingQuantityFilter : "",
    waterSupplyFilter : "",
    concentrationFilter : "",
    granularityFilter : "",
    steelBallFilter : "",
    filterCakeWater1Filter : "",
    filterCakeWater2Filter : "",
    filterCakeWater3Filter : "",
    filterCakeWater4Filter : "",
    filterCakeWater301Filter : "",
    slurryFixedCarbonFilter : "",
    pulpCaContentFilter : "",
    stronglyMixedWaterFilter : "",
    rawBallCarbonFilter : "",
    rawBallDropStrengthFilter : "",
    ripeBallStrengthFilter : "",
    conversionIndexFilter : "",
    abrasionIndexFilter : "",
    so2Filter : "",
    noxFilter : "",
    pmFilter : "",
    recorderIdFilter : "",
    reviewerIdFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'locationIdFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.locationId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'recordTimeRteFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.recordTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'recordTimeLteFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.recordTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'currentFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.current',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'grindingQuantityFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.grindingQuantity',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'waterSupplyFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.waterSupply',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'concentrationFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.concentration',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularityFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.granularity',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'steelBallFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.steelBall',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'filterCakeWater1Filter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.filterCakeWater1',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'filterCakeWater2Filter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.filterCakeWater2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'filterCakeWater3Filter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.filterCakeWater3',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'filterCakeWater4Filter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.filterCakeWater4',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'filterCakeWater301Filter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.filterCakeWater301',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slurryFixedCarbonFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.slurryFixedCarbon',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pulpCaContentFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.pulpCaContent',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'stronglyMixedWaterFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.stronglyMixedWater',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rawBallCarbonFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.rawBallCarbon',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rawBallDropStrengthFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.rawBallDropStrength',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ripeBallStrengthFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.ripeBallStrength',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'conversionIndexFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.conversionIndex',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'abrasionIndexFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.abrasionIndex',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'so2Filter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.so2',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'noxFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.nox',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pmFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.pm',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'recorderIdFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.recorderId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'reviewerIdFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.filter.reviewerId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'locationId',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.locationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'recordTime',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.recordTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'current',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.current',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'grindingQuantity',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.grindingQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'waterSupply',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.waterSupply',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'concentration',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.concentration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'granularity',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.granularity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'steelBall',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.steelBall',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'filterCakeWater1',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.filterCakeWater1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'filterCakeWater2',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.filterCakeWater2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'filterCakeWater3',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.filterCakeWater3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'filterCakeWater4',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.filterCakeWater4',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'filterCakeWater301',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.filterCakeWater301',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slurryFixedCarbon',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.slurryFixedCarbon',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pulpCaContent',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.pulpCaContent',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'stronglyMixedWater',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.stronglyMixedWater',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rawBallCarbon',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.rawBallCarbon',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rawBallDropStrength',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.rawBallDropStrength',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ripeBallStrength',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.ripeBallStrength',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'conversionIndex',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.conversionIndex',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'abrasionIndex',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.abrasionIndex',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'so2',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.so2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'nox',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.nox',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'pm',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.pm',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'recorderId',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.recorderId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'reviewerId',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.reviewerId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdPelletizingCeramicFilterParameter.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdPelletizingCeramicFilterParameter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
